const validateFindPlan = (values, errors) => {
    if (!values.enrollment.findPlan.zipCode) {
        errors.enrollment.findPlan.zipCode = 'Please enter a Zip Code';
    }
    if (!/[0-9]{4}$/i.test(values.enrollment.findPlan.coverageYear)) {
        errors.enrollment.findPlan.coverageYear = 'Please select Coverage Year';
    }
};
export default validateFindPlan;
